import { render, staticRenderFns } from "./AddHouseUsersToBatchForm.vue?vue&type=template&id=06393957"
import script from "./AddHouseUsersToBatchForm.vue?vue&type=script&lang=js"
export * from "./AddHouseUsersToBatchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports